// Entry point for the application
// This file exists to satisfy the build system's requirement for an index.js file
// The actual implementation is in index.tsx

// All imports must be at the top of the file (ESLint rule: import/first)
import { browserSessionPersistence, setPersistence } from 'firebase/auth';
import { auth } from './services/firebase';
// Import the main application entry point
import './index.tsx';

// Configure Firebase Auth persistence - helps with cross-origin issues
(async () => {
  try {
    // Using session persistence can help with some cross-origin issues
    await setPersistence(auth, browserSessionPersistence);
    console.log('Firebase Auth persistence set to SESSION');
  } catch (error) {
    console.error('Error setting auth persistence:', error);
  }
})();